<!-- 资金资产 -->
<template>
  <div class="bar_blog">
    <el-row :gutter="0" class="dashed">
      <el-col :span="12">
        <div class="grid-content bg-purple title1">资金资产</div>
      </el-col>
    </el-row>
    <el-row class="order-area">
      <el-tabs type="border-card">
        <el-tab-pane label="余额">
          <!--资金-->
          <div class="name_money clear">
            <span class="personal-money-tip">余额 &yen; </span>
            <span class="personal-money">{{getMoneyAjax.accounTotal || '0.00'}}</span>
            <span class="personal-money-one rt" @click="msg(1)">提现</span>
            <span class="personal-money-two rt" @click="msg(1)">充值</span>
          </div>
        </el-tab-pane>
        <el-tab-pane label="基金">
          <!--资金-->
          <div class="name_money clear">
            <span class="personal-money-tip">基金 &yen; </span>
            <span class="personal-money">{{getMoneyAjax.accounFund || '0.00'}}</span>
            <!-- <span class="personal-money-one rt">提现</span>  -->
            <span class="personal-money-two rt" @click="msg(2)">选旅行套餐</span>
          </div>
        </el-tab-pane>
        <el-tab-pane label="红包">
          <empty :acceptEmptyData="acceptData"></empty>
          <!-- <div class="name_money clear">您暂时还没有红包哦～</div> -->
        </el-tab-pane>
        <el-tab-pane label="优惠券">
          <empty :acceptEmptyData="acceptEmptyData"></empty>
          <!-- <div class="name_money clear">您暂时还没有优惠券哦～</div> -->
        </el-tab-pane>
      </el-tabs>    
    </el-row>
  </div>
</template>
<!--JS-->
<script>
  import { selectUserAccoun } from "api/apis";
  import empty from '../../components/common/empty'
  export default {
    components: {
      empty
    },
    data() {
      return {
        getMoneyAjax:{},//资金基金
        acceptData: {
          from: 'assets',
          msg: '您暂时还没有红包哦～'
        },
        acceptEmptyData: {
          from: 'assets',
          msg: '您暂时还没有优惠券哦～'
        },
      }
    },
    methods: {
      msg(index){
        if(index == 1){
          this.$message({
            message: '暂未开放！~',
            type: 'warning'
          });
        }
        if(index == 2){
          this.$message({
            message: '旅行产品即将上线，敬请期待！~',
            type: 'warning'
          });
        }

      },
      getMoneyFund () {//获取资金基金
        selectUserAccoun({uid: localStorage.getItem('pbw_user_pc_uid')}).then((res) =>{
          if (res.code == '000000') {
            this.getMoneyAjax = res.data
          } else {
            this.$message.warning(res.msg ? res.msg : '数据加载中，请稍后')
          }
        })
      },
    }
  }
</script>
<style lang="scss" scoped>
    @import '../../../src/scss/commonH5.scss';
    @import '../../scss/demo.scss';
    /* 基本资料 */
    .avatar{
      height: 120px;
      border-radius: 90px;
      border: 1px solid #d6d6d6;
    }
    .bar_blog .dashed {
      border-bottom: 1px dashed #F1F1F1;
      padding-bottom: 20px;
      margin-bottom: 25px;
    }
    .bar_blog .title1 {
      font-size: 18px;
      color: #333;
    }
    .bar_blog .title1::before {
      content: '';
      display: inline-block;
      width: 5px;
      height: 27px;
      border-radius: 5px;
      vertical-align: bottom;
      background-color: #F16202;
      margin-right: 20px;
    }
    .bar_blog .title2, .bar_blog .title2 em {
      text-align: right;
      font-size: 14px;
      color: #959595;
      line-height: 27px;
    }
    .bar_blog .repeatable {
      padding-bottom: 20px;
    }
    .bar_blog .repeatable .name {
      font-size: 14px;
      text-align: right;
      line-height: 40px;
    }
    .bar_blog .repeatable .in input {
      color: #F16202
    }
    .el-border{
      border-radius: 50%;
      width: 100px;
      height: 100px;
      line-height: 100px;
      border: 1px solid #ddd;
      text-align: center;
    }
    .bar_blog .repeatable .sex {
      line-height: 40px;
      padding-left: 10px;
    }

    .name_money{
      padding: 20px 80px;
      border: 1px solid #d5d5d5;
      span{
        color: #f60;
      }
    }

    .personal-money-tip{
      font-size: 24px;
    }
    .personal-money{
      font-size: 56px;
      font-weight: bold;
    }
    .personal-money-btn{
      color: #fff !important;
      background: #698adb;
      padding: 16px 50px;
      border-radius: 10px;
      font-size: 18px;
    }
    .personal-money-btm-tip{
      color: #999 !important;
      float: right;
      margin-top: -20px;
      margin-right: 30px;
    }
    .personal-money-one{
      color: #fff !important;
      background: #698adb;
      padding: 6px 30px;
      border-radius: 10px;
      font-size: 16px;
      margin-top: 24px;
      cursor: pointer;
    }
    .personal-money-two{
      color: #fff !important;
      background: #26b3f4;
      padding: 6px 30px;
      border-radius: 10px;
      font-size: 16px;
      margin-top: 24px;
      margin-right: 20px;
      cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/views/home/assets.vue